export default __webpack_public_path__ + "static/media/question.1593c8a6.svg";